// extracted by mini-css-extract-plugin
export default {"AppLoader":"AppLoader_AppLoader__JZevA","fullScreen":"AppLoader_fullScreen__aiOIY"};